import { useNotifications, useRelodeFormik } from "@relode/core";
import * as React from "react";

import { AddJobActions } from ".";
import { AddJobSteps } from "../types";
import { AddJobState } from "./addJobState";

export const useAddJobErrorHandlers = (
    state: AddJobState,
    actions: AddJobActions
) => {
    const { actions: notifications } = useNotifications();
    const {
        ui: { error, stepOneValidationErrors, stepTwoValidationErrors },
    } = state;
    const {
        setFieldTouched,
        formik__infra: { setFieldError },
    } = useRelodeFormik<AddJobSteps>();

    React.useEffect(() => {
        if (!error && !stepOneValidationErrors && !stepTwoValidationErrors) {
            return;
        } // we don't close from here.  might be odd

        if (error) {
            const message =
                error.message ??
                error.apiError?.friendlyMessages ??
                "we've encountered a problem";

            switch (error.type) {
                case "addJob": {
                    notifications.showArea("error", message, "wizardErrorArea");
                    break;
                }
                default: {
                    if (error.apiError.summary) {
                        notifications.showModal(
                            "error",
                            "we're sorry",
                            message,
                            {
                                callback: () => {
                                    actions.clearError();
                                },
                            }
                        );
                    }
                }
            }
        }

        const combinedValidationErrors = [];

        if (stepOneValidationErrors?.length ?? 0 > 0) {
            combinedValidationErrors.push(...stepOneValidationErrors);
        }

        if (stepTwoValidationErrors?.length ?? 0 > 0) {
            combinedValidationErrors.push(...stepTwoValidationErrors);
        }

        combinedValidationErrors?.forEach(ve => {
            const fieldName = error?.currentStep
                ? `${error.currentStep}.${ve.field}`
                : ve.field;
            setFieldError(
                fieldName as keyof AddJobSteps,
                ve.messages.join(" ")
            );
            setFieldTouched(fieldName as keyof AddJobSteps);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, stepOneValidationErrors, stepTwoValidationErrors]);
};
